import {
  AttributeValue,
  CustomFormAttribute,
  FormSubmission,
} from 'lib-shared-types-api';

import { FieldSubmission, FormSubmissionData } from '../../customForms.types';

export function formSubmissionConverter(
  formSubmission: FormSubmission,
  attributes: CustomFormAttribute[],
  dataFilter: (item: FormSubmission['values'][number]) => boolean = () => true,
): FormSubmissionData {
  return {
    submissionId: formSubmission.id,
    formId: formSubmission.form_id,
    formVersion: formSubmission.form_version.toString(),
    submissionData: formSubmission.values
      .filter(dataFilter)
      .reduce(
        (acc: Record<string, FieldSubmission>, { attribute_id, value }) => {
          acc[attribute_id] = convertAttributeValue(
            value,
            attributes.find((f) => f.id === attribute_id),
          );
          return acc;
        },
        {},
      ),
    locale: formSubmission.locale,
  };
}

function replaceOptionValuesWithLabels(
  value: string[],
  options: CustomFormAttribute['options'],
  idx = 0,
): string[] | null {
  const option = options.find((op) => value[idx] === op.value);
  if (!option?.label) {
    return null;
  }

  if (value.length - 1 > idx) {
    const subResult = replaceOptionValuesWithLabels(
      value,
      option.sub_options ?? [],
      idx + 1,
    );
    return subResult ? [option.label, ...subResult] : null;
  }

  return [option.label];
}

function convertAttributeValue(
  x: AttributeValue,
  field: CustomFormAttribute | undefined,
): FieldSubmission {
  switch (x.data_type) {
    case 'string':
      return {
        type: x.data_type,
        value: x.value,
      };
    case 'string_list':
      return {
        type: 'stringArray',
        value:
          replaceOptionValuesWithLabels(x.value, field?.options ?? []) ??
          x.value,
      };
    case 'file_list':
      const { value } = x;
      return {
        type: 'fileArray',
        value: value.map(
          ({ relative_url, name, media_type, bytes_length }) => ({
            relative_url,
            name,
            media_type,
            bytes_length,
          }),
        ),
      };
  }
}
